var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollective(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFF7F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12183)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_12183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.3168,
    cy: 10.5834,
    r: 2.30553,
    stroke: "url(#paint0_linear_1_12183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1665 18.9997V16.5935C16.1665 15.9591 10.8729 14.5153 8.56165 16.5935",
    stroke: "url(#paint1_linear_1_12183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46631 19.0001V16.5939C9.02776 15.872 13.0381 14.5153 16.2601 16.594",
    stroke: "url(#paint2_linear_1_12183)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_12183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.22547,
    cy: 10.5555,
    r: 1.05555,
    stroke: "url(#paint3_linear_1_12183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15.1144V13.7802C5.3113 13.38 6.60096 12.7663 9.26924 13.5134",
    stroke: "url(#paint4_linear_1_12183)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_12183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.4476,
    cy: 10.5555,
    r: 1.05555,
    stroke: "url(#paint5_linear_1_12183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6733 15.1996V13.8654C19.362 13.4652 18.0724 12.8515 15.4041 13.5986",
    stroke: "url(#paint6_linear_1_12183)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_12183",
    x: 6.96631,
    y: 7.77783,
    width: 10.7002,
    height: 13.2223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.53 0 0 0 0 0.53 0 0 0 0 0.53 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_12183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_12183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_12183",
    x: 3.5,
    y: 9,
    width: 6.90381,
    height: 8.11438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.53 0 0 0 0 0.53 0 0 0 0 0.53 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_12183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_12183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_12183",
    x: 14.2695,
    y: 9,
    width: 6.90381,
    height: 8.19958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.53 0 0 0 0 0.53 0 0 0 0 0.53 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_12183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_12183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_12183",
    x1: 9.50729,
    y1: 10.5834,
    x2: 15.1206,
    y2: 10.5834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC95"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF6D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_12183",
    x1: 16.1718,
    y1: 17.2559,
    x2: 8.56397,
    y2: 17.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC95"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF6D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_12183",
    x1: 8.46084,
    y1: 17.244,
    x2: 16.2577,
    y2: 17.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC95"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF6D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_12183",
    x1: 5.66774,
    y1: 10.5556,
    x2: 8.78007,
    y2: 10.5556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC95"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF6D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_12183",
    x1: 4.997,
    y1: 14.1379,
    x2: 9.26793,
    y2: 14.1379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC95"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF6D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_12183",
    x1: 15.8899,
    y1: 10.5556,
    x2: 19.0022,
    y2: 10.5556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC95"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF6D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_12183",
    x1: 19.6763,
    y1: 14.2231,
    x2: 15.4054,
    y2: 14.2231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC95"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF6D33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollective);
export default __webpack_public_path__ + "static/media/Collective.ec9fc5c723e54105a25debbce7e7d56c.svg";
export { ForwardRef as ReactComponent };